const UTILS = require("./utils.js");
module.exports = function () {
  var f;
  this.divs = [];
  this.update = function (g) {
    for (var h = this.divs.length - 1; h >= 0; --h) {
      if ((f = this.divs[h]).delay > 0) {
        f.delay -= g;
        if (f.delay <= 0) {
          f.style.display = "inline-block";
        }
      } else {
        if (f.scale > f.minScale) {
          f.scale -= f.scaleSpeed * g;
          if (f.scale <= f.minScale) {
            f.scale = f.minScale;
          }
          f.style.fontSize = f.scale + "px";
        }
        if (f.scaleSpd) {
          f.startS += f.scaleSpd * g;
          f.style.width = f.startS + "px";
          f.style.height = f.startS + "px";
        }
        f.life -= g;
        if (f.life <= 0) {
          f.style.display = "none";
          var j = f.callback;
          this.divs.splice(h, 1);
          if (j) {
            j();
          }
        }
        if (f.fade && f.life <= f.fade) {
          f.style.opacity = f.life / f.fade;
        }
        if (f.srcA && f.srcA.cnt && f.maxLife - f.life <= f.srcA.tim) {
          var k = Math.floor(f.srcA.cnt * ((f.maxLife - f.life) / f.srcA.tim));
          f.src = UTILS.assetsUrl("/textures/" + f.srcA.src + "_" + k + ".png");
        }
      }
    }
  };
  this.animateText = function (g, h, j, k, l, m, p, q) {
    if (this.divs.indexOf(g) < 0) {
      this.divs.push(g);
    }
    g.delay = p;
    if (!p) {
      g.style.display = "inline-block";
    }
    g.style.fontSize = j + "px";
    g.scale = j;
    g.minScale = k ? j * 0.4 : j;
    g.innerHTML = h;
    g.scaleSpeed = k;
    g.life = l;
    g.fade = m;
    g.style.opacity = 1;
    g.callback = q;
  };
  this.animateDiv = function (g, h, j, k, l, m) {
    if (this.divs.indexOf(g) < 0) {
      this.divs.push(g);
    }
    g.style.display = "block";
    g.life = h;
    g.maxLife = h;
    g.srcA = m;
    if (m) {
      g.src = UTILS.assetsUrl("/textures/" + m.src + "_0.png");
    }
    g.style.opacity = 1;
    g.fade = j;
    if (k) {
      g.style.width = k + "px";
      g.style.height = k + "px";
      g.startS = k;
      g.scaleSpd = l;
    }
  };
  this.reset = function () {
    for (var g = 0; g < this.divs.length; ++g) {
      this.divs[g].style.display = "none";
    }
    this.divs.length = 0;
  };
};
